/* system-cms-prefix start */
const prefix = '/cmsmanager'
/* system-cms-prefix change const prefix = '/cmsadmin' system-cms-prefix change */
/* system-cms-prefix end */

export default {
  // 微信授权-公众号
  weChatGrantAuth: `/weChat/grantAuth`,
  // 微信公众号分页
  wechatInfoPage: `${prefix}/wechatInfo/page`,
  // 微信公众号列表
  wechatInfoList: `${prefix}/wechatInfo/list`,
  // 微信推送预览
  contentextPreview: `${prefix}/contentext/preview`,
  // 微信推送
  contentextPush: `${prefix}/contentext/push`,
  // 微信-标签列表
  wechattagsApp: `${prefix}/wechattags/app`,
  // 微信-同步标签
  wechattagsSyncTags: `${prefix}/wechattags/syncTags`,
  // 微信-新建，修改，删除
  wechattags: `${prefix}/wechattags`,
  // 微信-查标签是否存在
  wechattagsCheck: `${prefix}/wechattags/check`,
  // 微信-设置标签
  wechattagsSet: `${prefix}/wechattags/set`,
  // 取消授权
  wechatInfo: `${prefix}/wechatInfo`,
  // 取消授权
  wechatInfoNoauthList: `${prefix}/wechatInfo/noauth/list`,
  // 设置默认登录授权账号
  wechatInfoDefault: `${prefix}/wechatInfo/default`,
  // 获取小程序最新服务类目
  wechatInfoCategory: `${prefix}/wechatInfo/category`,
  // 获取开发版本
  miniprogramversionRecord: `${prefix}/miniprogramversion/submit/record`,
  // 获取审核版本，提交审核，撤销审核
  miniprogramversionAudit: `${prefix}/miniprogramversion/audit`,
  // 获取线上版本，发布小程序
  miniprogramversionRelease: `${prefix}/miniprogramversion/release`,
  // 提交代码
  miniprogramversionSubmit: `${prefix}/miniprogramversion/submit`,
  // 修改线上版本状态
  miniprogramversionReleaseStatus: `${prefix}/miniprogramversion/release/status`,
  // 提交代码的页面配置
  miniprogramversionLeaf: `${prefix}/miniprogramversion/leaf`,
  // 小程序可选类目名称
  miniprogramversionCategory: `${prefix}/miniprogramversion/category`,
  // 获取体验二维码
  miniprogramversionQrcode: `${prefix}/miniprogramversion/qrcode`,
  // 小程序显示
  miniprogramversionButton: `${prefix}/miniprogramversion/button`,
  // 体验者列表
  miniprogrammemberList: `${prefix}/miniprogrammember/list`,
  // 体验者新增，删除
  miniprogrammember: `${prefix}/miniprogrammember`,
  // 小程序服务器列表
  wechatInfoDisplayModifyDomain: `${prefix}/wechatInfo/displayModifyDomain`,
  // 小程序服务器列表-重置
  wechatInfoModifyDomain: `${prefix}/wechatInfo/modifyDomain`,
  // 菜单列表
  wechatmenugroupPage: `${prefix}/wechatmenugroup/page`,
  // 菜单-新增、修改
  wechatMenu: `${prefix}/wechatMenu`,
  // 菜单-删除
  wechatmenugroup: `${prefix}/wechatmenugroup`,
  // 菜单-状态生效
  wechatmenugroupStatus: `${prefix}/wechatmenugroup/status`,
  // 素材-列表
  wechatMaterialPage: `${prefix}/wechatMaterial/page`,
  // 素材-查询，删除
  wechatMaterial: `${prefix}/wechatMaterial`,
  // 素材-新增图文素材,修改
  wechatMaterialNews: `${prefix}/wechatMaterial/news`,
  // 素材-新增其他素材
  wechatMaterialMaterial: `${prefix}/wechatMaterial/material`,
  // 素材-新增视频素材
  wechatMaterialVideo: `${prefix}/wechatMaterial/video `,
  // 素材-上传图片返回URL，此处建议在新建永久图文素材时使用
  wechatMaterialUploadImg: `${prefix}/wechatMaterial/upload/img`,
  // 素材-同步图文素材
  wechatMaterialSynchNews: `${prefix}/wechatMaterial/synch/news`,
  // 素材-同步其他素材
  wechatMaterialSynchMaterial: `${prefix}/wechatMaterial/synch/material`,
  // 素材-同步服务器图片
  wechatMaterialSynchImg: `${prefix}/wechatMaterial/synch/img`,
  // 素材-下载视频素材
  wechatMaterialDowloadVideo: `${prefix}/wechatMaterial/dowload/video`,
  // 素材-下载素材
  wechatMaterialDowloadMaterial: `${prefix}/wechatMaterial/dowload/material`,
  // 回复信息列表
  wechatreplycontentPage: `${prefix}/wechatreplycontent/page`,
  // 关键词列表
  keyWordList: `${prefix}/keyWord/list`,
  // 添加自动回复
  keyWord: `${prefix}/keyWord`,
  // 修改自动回复
  wechatreplycontent: `${prefix}/wechatreplycontent`,
  // 事件回复
  wechatreplyclick: `${prefix}/wechatreplyclick`,
  // 小程序代码分页
  wechatMiniprogramCodePage: `${prefix}/miniprogramCode/page`,
  // 同步草稿箱
  wechatMiniprogramCodeSynchDraft: `${prefix}/miniprogramCode/synch/draft`,
  // 同步模板库
  wechatMiniprogramCodeSynchTemplate: `${prefix}/miniprogramCode/synch/template`,
  // 转换模板
  wechatMiniprogramCodeTemplate: `${prefix}/miniprogramCode/template`,
  // 设置最新模板
  wechatMiniprogramCodeTemplateStatus: `${prefix}/miniprogramCode/template/status`,
  // 粉丝列表分页
  wechatfansPage: `${prefix}/wechatfans/page`,
  // 黑名单，拉黑
  wechatfansBlack: `${prefix}/wechatfans/black`,
  // 粉丝详情
  wechatfans: `${prefix}/wechatfans`,
  // 发送消息
  wechatfansSend: `${prefix}/wechatfans/send`,
  // 同步粉丝
  wechatfansSync: `${prefix}/wechatfans/sync`,
  // 同步多个粉丝
  wechatfansSyncFans: `${prefix}/wechatfans/syncFans`,
  // 取消拉黑
  wechatfansCancelblack: `${prefix}/wechatfans/cancelblack`,
  // 本月群发-列表
  wechatsendList: `${prefix}/wechatsend/list`,
  // 本月群发-新增，修改，删除,详情
  wechatsend: `${prefix}/wechatsend`,
  // 推送汇总
  wechatsendCollect: `${prefix}/wechatsend/collect`,
  // 消息列表分页
  wechatfanssendlogPage: `${prefix}/wechatfanssendlog/page`,
  // 群发文章列表
  wechatcommentArticles: `${prefix}/wechatcomment/articles`,
  // 群发文章列表
  wechatcommentPage: `${prefix}/wechatcomment/page`,
  // 粉丝统计用户增长
  wechatStatistics: `${prefix}/statistics`,
  // 粉丝统计趋势图
  wechatStatisticsMap: `${prefix}/statistics/map`,
  // 粉丝统计用户属性性别
  wechatStatisticsSex: `${prefix}/statistics/sex`,
  // 粉丝统计用户省份信息
  wechatStatisticsProvince: `${prefix}/statistics/province`,
  // 粉丝统计用户省份列表
  wechatStatisticsProvinceList: `${prefix}/statistics/province/list`,
  // 粉丝统计用户城市信息
  wechatStatisticsCity: `${prefix}/statistics/city`,
  // 粉丝统计用户语言信息
  wechatStatisticsLga: `${prefix}/statistics/lga`,
  // 粉丝统计下载表格
  wechatStatisticsDownload: `${prefix}/statistics/download`,
  // 用户增长列表分页
  wechatStatisticspage: `${prefix}/statistics/page`,
  // 统计汇总用户增长
  wechatStatisticsCollect: `${prefix}/statistics/collect`,
  // 统计汇总趋势汇总
  wechatStatisticsMapCollect: `${prefix}/statistics/map/collect`,
  // 统计汇总性别汇总
  wechatStatisticsSexCollect: `${prefix}/statistics/sex/collect`,
  // 统计汇总省份汇总
  wechatStatisticsProvinceCollect: `${prefix}/statistics/province/collect`,
  // 统计汇总城市汇总
  wechatStatisticsCityCollect: `${prefix}/statistics/city/collect`,
  // 统计汇总语言汇总
  wechatStatisticsLgaCollect: `${prefix}/statistics/lga/collect`,
  // 统计汇总语言汇总
  wechatcommentReply: `${prefix}/wechatcomment/reply`,
  // 统计汇总增长列表分页汇总
  wechatfansStatisticsPageSum: `${prefix}/statistics/pageSum`,
  // 同步粉丝黑名单
  wechatfansSyncblack: `${prefix}/wechatfans/syncblack`,
  // 手动同步消息
  wechatcommentHand: `${prefix}/wechatcomment/hand`,
  // 留言设置开启
  wechatcommentOn: `${prefix}/wechatcomment/on`,
  // 留言设置关闭
  wechatcommentOff: `${prefix}/wechatcomment/off`,
  // 设置留言为精选
  wechatcommentMarkelect: `${prefix}/wechatcomment/markelect`,
  // 取消留言精选
  wechatcommentUnmarkelect: `${prefix}/wechatcomment/unmarkelect`,
  // 删除留言
  wechatcomment: `${prefix}/wechatcomment`,
  // 内容-栏目树
  contentCommonTree: `${prefix}/channel/content/common/tree`,
  // 立即群发
  wechatsendSend: `${prefix}/wechatsend/send`

}
